import { useMutation } from "@tanstack/react-query";

// Empty string means use current origin (for proxied setup), undefined means use localhost
const API_URL = import.meta.env.VITE_API_URL !== undefined
  ? import.meta.env.VITE_API_URL
  : "http://localhost:3000";

async function post(path: string, body: unknown) {
  const response = await fetch(`${API_URL}${path}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify(body),
  });
  const data = await response.json().catch(() => ({}));
  return { ok: response.ok, data };
}

export function useSendOtp() {
  return useMutation<void, Error, { email: string }>({
    mutationFn: async ({ email }) => {
      const { ok } = await post("/api/auth/onboarding/send-otp", { email });
      if (!ok) throw new Error("Unable to send code");
    },
  });
}

export function useVerifyOtp() {
  return useMutation<{ ok: boolean; reason?: string }, Error, { email: string; code: string }>({
    mutationFn: async ({ email, code }) => {
      const { data } = await post("/api/auth/onboarding/verify-otp", { email, code });
      return data;
    },
  });
}

export function useSetPasswordWithOtp() {
  return useMutation<{ success?: boolean; error?: string; reason?: string }, Error, { email: string; code: string; password: string }>({
    mutationFn: async ({ email, code, password }) => {
      const { ok, data } = await post("/api/auth/onboarding/set-password", { email, code, password });
      if (!ok) throw new Error(data.error || data.reason || "Unable to set password");
      return data;
    },
  });
}
